import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { Link } from 'components/core/Link';
import { Text } from 'components/core/Text';
import AccordionMenuItem from './AccordionMenuItem';

export function MenuItem(props) {
	const { href, text, rightAlign } = props;
	if (!href) return <AccordionMenuItem {...props} />;
	return (
		<Link
			href={href}
			className={classnames('header-link', {
				'menu-secondary': rightAlign,
			})}
			target={
				href.includes('storageguide') || href.includes('blog.sparefoot')
					? '_blank'
					: '_self'
			}
		>
			<Text size="tiny">{text}</Text>
		</Link>
	);
}

MenuItem.propTypes = {
	href: PropTypes.string,
	text: PropTypes.string,
	rightAlign: PropTypes.bool
};

export default MenuItem;
